export const getCarouselState = (emblaApi) => {
  if (!emblaApi) return {};

  const { options = {} } = emblaApi.internalEngine();
  const hasItemsToScroll = emblaApi.scrollSnapList().length > 1;

  return {
    ...options,
    hasItemsToScroll,
  };
};
